// src/redux/features/slices/sms.ts
import { createSlice } from "@reduxjs/toolkit";
import { GetSMSThunk, ResendSMSThunk } from "../actions/sms";

type StatusType = "idle" | "pending" | "success" | "error";

const initialState = {
  list: [] as any[],
  info: {} as any,
  status: "idle" as StatusType,
  error: undefined as string | any,
  fetchTimes: 0,
  filters: {} as any,
};

export const SMSSlice = createSlice({
  name: "sms",
  initialState,
  reducers: {
    setFilters: (state, { payload }) => {
      state.filters = payload;
    },
    resetSMSState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Get SMS List
      .addCase(GetSMSThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(GetSMSThunk.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error.message;
      })
      .addCase(GetSMSThunk.fulfilled, (state, { payload, meta: { arg } }) => {
        const { list, ...info } = payload;
        if (arg) state.filters = arg;
        state.status = "success";
        state.list = list;
        state.info = info;
        state.fetchTimes += 1;
      })
      
      // Resend SMS
      .addCase(ResendSMSThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(ResendSMSThunk.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error.message;
      })
      .addCase(ResendSMSThunk.fulfilled, (state) => {
        state.status = "success";
      });
  },
});

export const { setFilters, resetSMSState } = SMSSlice.actions;
export default SMSSlice.reducer;